export default __webpack_public_path__ + "static/desktop_menu_KV07-d465d7a7c9d81749956b556e4a2e867f.mp4";